<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin"
            @onSearchClicked="searchView"/>
        <alert
            :show="alertVisible"
            :message="message"
            :variant="variant"
            @alertShown=alertShown
            @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div class="mx-auto ml-auto" v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <!--<b-container class="mb-3 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3 class="info-subtitle palette-primary">{{ this.categoryId ? $t("categories." + this.categoryId) : "" }}</h3>
                        </b-col>
                    </b-container>-->
                    <b-container v-if="this.categoryId !== CATEGORY_SPORTS" class="mb-4 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t("common.aid_organizations_and_foundations") }}</h3>
                        </b-col>
                    </b-container>
                    <b-container v-if="this.categoryId === CATEGORY_SPORTS" class="mb-4 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t("common.sportType") }}</h3>
                        </b-col>
                    </b-container>
                    <category-organizations-feed :organizations="this.organizations"/>
                    <div v-if="loading"
                         id="loader"
                         class="spinner">
                    </div>
                </div>
                <!-- Do not show clubs at all
                <div class="mx-auto ml-auto"
                     v-if="!showLogIn && this.categoryId === CATEGORY_SPORTS">
                    <b-container class="mb-4 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t("common.clubs_and_associations") }}</h3>
                        </b-col>
                    </b-container>
                    <team-feed :category="this.categoryId"/>
                </div>
                -->
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
import Login from "../components/Login";
import Alert from '../components/Alert'
import {alertMixin} from "../mixins/AlertMixin";
import CategoryOrganizationsFeed from "../components/feed/CategoryOrganizationsFeed";
import TopBar from "../components/TopBar";
// import TeamFeed from "../components/feed/TeamFeed";
import FooterArea from "../components/FooterArea";
import FairApi from "@/modules/api";
import BreadCrumbs from "@/components/BreadCrumbs";

export default {
    name: "CategoryOrganizationsView",
    mixins: [alertMixin],
    components: {BreadCrumbs, FooterArea, TopBar, Alert, Login, CategoryOrganizationsFeed, /*TeamFeed*/}, //CampaignFeed,
    data() {
        return {
            showLogIn: false,
            showSearchField: false,
            category: -1,
            note: false,
            categoryId: null,
            organizations: [],
            loading: true,
            breadcrumbs: [],
            CATEGORY_SPORTS: 4
        }
    },

    watch: {
        categoryId: function () {
            if (this.categoryId !== null)
                this.fetchOrganizations()
        },
    },

    mounted: function () {
        this.categoryId = parseInt(this.$route.params.id);
        this.setBreadcrumbs()
    },

    methods: {
        searchView : function () {
            this.showLogIn = false
            this.$router.push({name: 'search-view'})
        },

        showLogin: function () {
            this.showLogIn = true
        },

        showMain: function () {
            this.showLogIn = false
        },

        showNote: function () {
            this.note = true
            this.showAlert(this.$t('login.link_send'), "info")
        },

        alertDismiss: function () {
            if (this.note) {
                this.showLogIn = false
                this.note = false
            }
        },

        setCategory(category) {
            this.category = category
        },

        fetchOrganizations: function () {
            this.loading = true
            this.visibleResults = []
            // get active and open campaigns
            let param = {
                category: this.categoryId
            }
            FairApi.getWithParams(FairApi.organization(), param,
                this.success, this.failed)
        },

        success: function (response) {
            this.results = response
            //.filter(function (item) {
            // if (item.organization.stripe_id) {
            //     return true
            // }
            // return false
            //  })
            this.organizations = this.results;
            this.loading = false
        },

        failed: function () {
            this.loading = false
        },

        setBreadcrumbs: function () {
            this.breadcrumbs = [
                {
                    text: "breadcrumbs.front_page",
                    translate: true,
                    route: 'main-view',
                    disabled: false,
                    active: false
                },
                {
                    text: "categories." + this.categoryId,
                    translate: true,
                    route: 'category-organizations-view',
                    disabled: true,
                    active: true
                }
            ]
        },

        showAdminView: function () {
          this.showLogIn = false
          this.$router.push({name: 'admin-view'})
        },

        showCampaignView: function () {
          this.showLogIn = false
        },
    }
}
</script>

<style scoped>

</style>